import { AsYouType  } from 'libphonenumber-js';

// Put phone number into the appropriate format for the specified country.
// Example: For a US phone number, "9736018200" becomes "(973) 601-8200"
// If the phone number is not valid, it will return the input string.
const formatPhone = country => value => new AsYouType(country).input(value || '');

export default formatPhone;
